
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Clamped extends Vue {
    @Prop() clampedClass: string;

    mounted() {
        this.checkClamped();
    }

    updated() {
        this.checkClamped();
    }

    checkClamped() {
        if (this.$el.clientHeight < this.$el.scrollHeight) {
            this.$el.classList.add(this.clampedClass);
        } else {
            this.$el.classList.remove(this.clampedClass);
        }
    }
}
